var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-container--bottom"},[_c('button',{directives:[{name:"lang",rawName:"v-lang.activarGeolocalizacion",modifiers:{"activarGeolocalizacion":true}}],staticClass:"btn btn-cancel btn-lg btn-heavy",on:{"click":_vm.onActivateLocation}},[_vm._v("\n        Activar geolocalización\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4980bd30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/OnLocationOff.vue
// module id = HWkC
// module chunks = 1